<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">전자 계약</span>
            <span class="txt">
                발송한 계약서 내역을 확인하고, 자주 쓰는 템플릿(서식)을 등록하거나 수정할 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <span v-for="(item, index) in submenus" :key="index">
                    <router-link
                        v-show="item.valid"
                        :class="{ on: $route.name == item.name }"
                        :to="{ ...item, params: { centerId } }"
                    >
                        {{ item.label }}
                    </router-link>
                </span>
            </div>

            <div class="com-table-content">
                <div class="table-top-container">
                    <div class="left-box">
                        <p class="table-top-title"><strong>약관</strong></p>
                    </div>
                    <div class="right-box">
                        <span class="table-top-count" style="margin-right: 10px">
                            총
                            <span class="blue">{{ termList.length }}</span>
                            개
                        </span>
                        <a class="com-btn red" style="margin-right: 10px" @click="deleteTerm">삭제</a>
                        <a class="com-btn blue" @click="registerTerm">등록</a>
                    </div>
                </div>
                <div style="margin-bottom: 20px" v-show="copiedTermsList.length > 0">
                    <span>복사된 항목명:</span>
                    <span v-for="(c, ci) in copiedTermsList">
                        {{
                            termList[c.index].s_title +
                            (c.count > 1 ? '(' + c.count + ')' : '') +
                            (ci < copiedTermsList.length - 1 ? ',' : '')
                        }}
                    </span>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 60px" />
                        <col style="width: 200px" />
                        <col style="width: 500px" />
                        <col style="width: 100px" />
                        <col style="width: 140px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all"
                                        v-model="selectedTermAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedTermAll"
                                    />
                                    <label for="check-all"></label>
                                </div>
                            </th>
                            <th>항목명</th>
                            <th>내용 미리보기</th>
                            <th>사용유무</th>
                            <th>관리</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, index) in termList" :key="index">
                            <td>
                                <div class="com-check">
                                    <input
                                        :id="t.s_id"
                                        v-model="selectedTerm"
                                        :value="index"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label :for="t.s_id"></label>
                                </div>
                            </td>
                            <td>
                                <div style="width: 22vw">
                                    <div class="line-blind">{{ t.s_title }}</div>
                                </div>
                            </td>
                            <td class="left">
                                <div style="width: 40vw">
                                    <div class="line-blind">{{ t.s_content }}</div>
                                </div>
                            </td>
                            <td>
                                <div class="com-design-check">
                                    <input
                                        :id="`term-${index}`"
                                        v-model="t.s_use_yn"
                                        :name="`term-name-${t.s_id}`"
                                        type="checkbox"
                                        @change="onSaveTermUse(index, $event.target.checked)"
                                    />
                                    <label :for="`term-${index}`"></label>
                                </div>
                            </td>
                            <td>
                                <button class="com-btn white" @click="onCopyTerm(index)">복사</button>
                                <button class="com-btn" @click="onModifyTerm(index)">수정</button>
                            </td>
                        </tr>
                        <tr v-if="termList.length === 0">
                            <td colspan="100">등록된 내역이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="com-table-content">
                <div class="table-top-container">
                    <div class="left-box">
                        <p class="table-top-title"><strong>동의/선택</strong></p>
                    </div>
                    <div class="right-box">
                        <span class="table-top-count" style="margin-right: 10px">
                            총
                            <span class="blue">{{ this.agreeList.length }}</span>
                            개
                        </span>
                        <a class="com-btn red" style="margin-right: 10px" @click="deleteAgree">삭제</a>
                        <a class="com-btn blue" @click="registerAgree">등록</a>
                    </div>
                </div>

                <div style="margin-bottom: 20px" v-show="copiedAgreeList.length > 0">
                    <span>복사된 항목명:</span>
                    <span v-for="(c, ci) in copiedAgreeList">
                        {{
                            agreeList[c.index].s_title +
                            (c.count > 1 ? '(' + c.count + ')' : '') +
                            (ci < copiedAgreeList.length - 1 ? ',' : '')
                        }}
                    </span>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 60px" />
                        <col style="width: 200px" />
                        <col style="width: 500px" />
                        <col style="width: 100px" />
                        <col style="width: 140px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all-agree"
                                        v-model="selectedAgreeAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedAgreeAll"
                                    />
                                    <label for="check-all-agree"></label>
                                </div>
                            </th>
                            <th>항목명</th>
                            <th>내용 미리보기</th>
                            <th>사용유무</th>
                            <th>관리</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, index) in agreeList" :key="index">
                            <td>
                                <div class="com-check">
                                    <input
                                        :id="t.s_id"
                                        v-model="selectedAgree"
                                        :value="index"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label :for="t.s_id"></label>
                                </div>
                            </td>
                            <td>
                                <div style="width: 22vw">
                                    <div class="line-blind">{{ t.s_title }}</div>
                                </div>
                            </td>
                            <td class="left">
                                <div style="width: 40vw">
                                    <div class="line-blind">{{ t.s_content }}</div>
                                </div>
                            </td>
                            <td>
                                <div class="com-design-check">
                                    <input
                                        :id="`agree-${index}`"
                                        v-model="t.s_use_yn"
                                        :name="`agree-name-${t.s_id}`"
                                        type="checkbox"
                                        @change="onSaveAgreeUse(index, $event.target.checked)"
                                    />
                                    <label :for="`agree-${index}`"></label>
                                </div>
                            </td>
                            <td>
                                <button class="com-btn white" @click="onCopyAgree(index)">복사</button>
                                <button class="com-btn" @click="onModifyAgree(index)">수정</button>
                            </td>
                        </tr>
                        <tr v-if="agreeList.length === 0">
                            <td colspan="100">등록된 내역이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <div v-show="termPop" class="layer-pop square">
            <div class="view-content small-padding" style="width: auto">
                <button class="close" @click="closeTermPopup">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style="font-size: 18px; margin-bottom: 15px">
                        약관 {{ selectedTermIndex == -1 ? '등록' : '수정' }}
                    </p>
                    <div style="display: flex; align-items: center; margin-bottom: 15px">
                        <span class="tit" style="margin-right: 30px">
                            항목명
                            <span class="imp">*</span>
                        </span>
                        <input
                            v-model="termName"
                            placeholder=""
                            type="text"
                            style="flex: 1"
                            maxlength="20"
                            @keydown="onKeydown($event)"
                        />
                    </div>
                    <textarea
                        v-model="termContent"
                        class="com-textarea"
                        style="width: 500px; height: 250px"
                        placeholder="• 내용을 입력해주세요"
                        @keyup="onKeyupTermContent($event)"
                    ></textarea>
                    <div class="bottom-btn" style="margin-top: 30px; padding-bottom: 0">
                        <button class="com-btn" @click="onCancelTerm">취소</button>
                        <button class="com-btn blue" @click="onSaveTerm">저장</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="agreePop" class="layer-pop square">
            <div class="view-content small-padding" style="width: auto">
                <button class="close" @click="closeAgreePopup">
                    <span class="blind">Popup Close</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style="font-size: 18px; margin-bottom: 15px">
                        동의/선택 {{ selectedAgreeIndex == -1 ? '등록' : '수정' }}
                    </p>
                    <div style="display: flex; align-items: center; margin-bottom: 15px">
                        <span class="tit" style="margin-right: 30px; font-size: 14px">
                            항목명
                            <span class="imp">*</span>
                        </span>
                        <input
                            v-model="agreeName"
                            placeholder=""
                            type="text"
                            style="flex: 1"
                            maxlength="20"
                            @keydown="onKeydown($event)"
                        />
                    </div>
                    <div class="agree-container">
                        <textarea
                            v-model="agreeContent"
                            class="com-textarea"
                            style="width: 500px; height: 200px; border: none; resize: none"
                            placeholder="• 내용을 입력해주세요."
                            @keyup="onKeyupAgreeContent($event)"
                        ></textarea>
                        <div style="padding: 20px 8px">
                            <div
                                v-for="(item, index) in agreeItems"
                                style="display: flex; align-items: center; margin-top: 10px"
                            >
                                <div class="com-check">
                                    <input
                                        :id="`agree-check-${index}`"
                                        v-model="item.checked"
                                        name="check-c1"
                                        type="checkbox"
                                        disabled
                                    />
                                    <label :for="`agree-check-${index}`" class="agree-option"></label>
                                </div>
                                <input
                                    v-model="item.title"
                                    class="agree-option-input"
                                    placeholder="선택 옵션을 입력하세요."
                                />
                                <img
                                    alt="Photo"
                                    src="/img/icons/ic_input_del_btn.jpg"
                                    style="width: 10px; margin-left: 10px"
                                    @click="onDeleteOption(index)"
                                />
                            </div>
                            <div style="margin-top: 10px">
                                <button class="com-btn blue" @click="onAddSelectionBox">+ 선택 박스 추가</button>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; align-items: center; margin-top: 10px">
                        <span class="tit" style="margin-right: 30px; font-size: 14px">
                            필수여부
                            <span class="imp">*</span>
                        </span>
                        <div class="com-design-check">
                            <input id="agree_required" v-model="agreeRequired" name="agree-required" type="checkbox" />
                            <label for="agree_required"></label>
                        </div>
                    </div>
                    <div class="bottom-btn" style="margin-top: 30px; padding-bottom: 0">
                        <button class="com-btn" @click="onCancelAgree">취소</button>
                        <button class="com-btn blue" @click="onSaveAgree">저장</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';

export default {
    name: 'ElectronicSetting',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
    },
    props: [],
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    watch: {},
    created() {},
    mounted() {
        this.init();
    },
    data() {
        return {
            centerId: 0,

            submenus: [
                { name: 'SettingElectronicContractManage', label: '계약 관리' },
                { name: 'SettingElectronicExternalDocument', label: '외부 문서' },
                { name: 'SettingElectronicTemplateManage', label: '템플릿 관리' },
                { name: 'SettingElectronicSignature', label: '서명' },
                { name: 'SettingElectronicSetting', label: '설정' },
            ],

            isLoading: false,

            termList: [],
            copiedTermsList: [],

            selectedTermAll: false,
            selectedTerm: [],

            agreeList: [],
            copiedAgreeList: [],

            selectedAgreeAll: false,
            selectedAgree: [],

            termPop: false,
            termName: '',
            termContent: '',

            agreePop: false,
            agreeName: '',
            agreeContent: '',
            agreeItems: [],
            agreeRequired: true,

            selectedTermIndex: -1,
            selectedAgreeIndex: -1,

            commonFlag: false,
        };
    },
    methods: {
        // 초기화
        async init() {
            this.centerId = parseInt(this.cId); // 센터id

            this.isLoading = true;

            this.setSubMenu();
            this.onSearchTermsList();
            this.onSearchAgreeList();

            this.isLoading = false;
        },

        setSubMenu() {
            this.submenus[0].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[1].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[2].valid = this.isAllowed('ME', 6);
            this.submenus[3].valid = this.isAllowed('ME', 6);
            this.submenus[4].valid = this.isAllowed('ME', 6);
        },

        async onSearchTermsList() {
            try {
                this.isLoading = true;

                const { data } = await api.get(
                    `/admin/api/term/${this.centerId}/${this.centerStaffId}/electronic/contract/term`
                );
                this.termList = data;

                // this.copiedTermsList = [];

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async onSearchAgreeList() {
            try {
                this.isLoading = true;

                const { data } = await api.get(
                    `/admin/api/term/${this.centerId}/${this.centerStaffId}/electronic/contract/agree`
                );
                this.agreeList = data;

                // this.copiedAgreeList = [];

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async deleteTerm() {
            if (this.selectedTerm.length == 0) {
                alert('계약서를 선택해 주세요.');
                return;
            }

            if (!confirm('삭제 하시겠습니까?')) return;

            const params = {
                selectedIds: this.termList
                    .filter((item, index) => this.selectedTerm.indexOf(index) >= 0)
                    .map((i) => i.s_id)
                    .toString(),
            };

            await api.delete(`/admin/api/term/electronic/contract/term`, {
                params,
            });

            this.selectedTerm = [];

            this.onSearchTermsList();
        },

        registerTerm() {
            this.initAddTermPopup();

            this.termPop = true;
        },

        checkedTermAll() {
            // 전체 선택 기능
            this.selectedTerm = [];
            if (!this.selectedTermAll) {
                for (const i in this.termList) {
                    this.selectedTerm.push(i);
                }
            }
        },

        checkedAgreeAll() {
            // 전체 선택 기능
            this.selectedAgree = [];
            if (!this.selectedAgreeAll) {
                for (const i in this.agreeList) {
                    this.selectedAgree.push(i);
                }
            }
        },

        async onCopyTerm(index) {
            const { data } = await api.post(
                `/admin/api/term/${this.centerId}/${this.centerStaffId}/electronic/contract/term/copy/${this.termList[index].s_id}`
            );
            if (data) {
                let flag = false;
                this.copiedTermsList.map((t) => {
                    if (t.index == index) {
                        flag = true;
                        t.count++;
                    }
                });

                if (!flag) {
                    this.copiedTermsList.push({ index: index, count: 1 });
                }

                this.onSearchTermsList();
            }
        },

        initAddTermPopup() {
            this.selectedTermIndex = -1;
            this.termName = '';
            this.termContent = '';
        },

        onModifyTerm(index) {
            this.initAddTermPopup();

            this.selectedTermIndex = index;

            this.termName = this.termList[index].s_title;
            this.termContent = this.termList[index].s_content;

            this.termPop = true;
        },

        onShowTerm(index) {},

        async deleteAgree() {
            if (this.selectedAgree.length == 0) {
                alert('계약서를 선택해 주세요.');
                return;
            }

            if (!confirm('삭제 하시겠습니까?')) return;

            const params = {
                selectedIds: this.agreeList
                    .filter((item, index) => this.selectedAgree.indexOf(index) >= 0)
                    .map((i) => i.s_id)
                    .toString(),
            };

            await api.delete(`/admin/api/term/electronic/contract/agree`, {
                params,
            });

            this.selectedAgree = [];

            this.onSearchAgreeList();
        },

        initAddAgreePopup() {
            this.selectedAgreeIndex = -1;

            this.agreeName = '';
            this.agreeContent = '';
            this.agreeItems = [];
            this.agreeRequired = true;
        },

        registerAgree() {
            this.initAddAgreePopup();

            this.agreePop = true;
        },

        async onCopyAgree(index) {
            const { data } = await api.post(
                `/admin/api/term/${this.centerId}/${this.centerStaffId}/electronic/contract/agree/copy/${this.agreeList[index].s_id}`
            );
            if (data) {
                let flag = false;
                this.copiedAgreeList.map((t) => {
                    if (t.index == index) {
                        flag = true;
                        t.count++;
                    }
                });

                if (!flag) {
                    this.copiedAgreeList.push({ index: index, count: 1 });
                }

                this.onSearchAgreeList();
            }
        },

        onModifyAgree(index) {
            this.initAddAgreePopup();

            this.selectedAgreeIndex = index;

            this.agreeName = this.agreeList[index].s_title;
            this.agreeContent = this.agreeList[index].s_content;
            this.agreeRequired = this.agreeList[index].s_required_flag;

            let options = [];
            if (this.agreeList[index].options) {
                this.agreeList[index].options.map((item) => {
                    options.push({
                        title: item.o_title,
                        checked: false,
                    });
                });
            }
            this.agreeItems = options;

            this.agreePop = true;
        },

        async onSaveTermUse(index, checked) {
            try {
                this.isLoading = true;

                await api.put(`/admin/api/term/electronic/contract/term/use`, {
                    id: this.termList[index].s_id,
                    state: checked,
                });

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        async onSaveAgreeUse(index, checked) {
            try {
                this.isLoading = true;

                await api.put(`/admin/api/term/electronic/contract/agree/use`, {
                    id: this.agreeList[index].s_id,
                    state: checked,
                });

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        closeTermPopup() {
            this.termPop = false;
        },

        onCancelTerm() {
            if (this.selectedTermIndex == -1) {
                this.closeTermPopup();
                return;
            }

            if (
                this.termList[this.selectedTermIndex].s_title == this.termName &&
                this.termList[this.selectedTermIndex].s_content == this.termContent
            ) {
                this.closeTermPopup();
            } else {
                if (confirm('약관정보가 변경되었습니. 취소하시겠습니까?')) {
                    this.closeTermPopup();
                }
            }
        },

        async onSaveTerm() {
            if (this.termName == '') {
                alert('항목명을 입력해주세요.');
                return;
            }

            if (this.termContent == '') {
                alert('내용을 입력해주세요.');
                return;
            }

            try {
                if (this.selectedTermIndex == -1) {
                    if (!confirm('약관을 등록하시겠습니까?')) {
                        return;
                    }
                } else {
                    if (
                        this.termList[this.selectedTermIndex].s_title == this.termName &&
                        this.termList[this.selectedTermIndex].s_content == this.termContent
                    ) {
                        alert('변경된 정보가 없습니다.');
                        return;
                    }

                    if (!confirm('약관을 수정하시겠습니까?')) {
                        return;
                    }
                }

                if (this.commonFlag) {
                    const { data } = await api.post(`/admin/api/term/electronic/contract/term`, {
                        id: this.selectedTermIndex == -1 ? 0 : this.termList[this.selectedTermIndex].s_id,
                        title: this.termName,
                        content: this.termContent,
                    });

                    if (data) {
                        if (this.selectedTermIndex == -1) {
                            alert('The term has been registered.');
                        } else {
                            alert('The term has been modified.');
                        }
                        this.closeTermPopup();
                    }
                } else {
                    const { data } = await api.post(
                        `/admin/api/term/${this.centerId}/${this.centerStaffId}/electronic/contract/term`,
                        {
                            id: this.selectedTermIndex == -1 ? 0 : this.termList[this.selectedTermIndex].s_id,
                            title: this.termName,
                            content: this.termContent,
                        }
                    );

                    if (data) {
                        if (this.selectedTermIndex == -1) {
                            alert('약관이 등록되었습니다.');
                        } else {
                            alert('약관이 수정되었습니다.');
                        }
                        this.closeTermPopup();
                    }
                }

                this.onSearchTermsList();
            } catch (error) {
                console.log(error);
            }
        },

        closeAgreePopup() {
            this.agreePop = false;
        },

        onCancelAgree() {
            if (this.selectedAgreeIndex == -1) {
                this.closeAgreePopup();
                return;
            }

            const selectedItem = this.agreeList[this.selectedAgreeIndex];
            if (
                selectedItem.s_title == this.agreeName &&
                selectedItem.s_content == this.agreeContent &&
                selectedItem.options &&
                this.agreeItems &&
                selectedItem.options.length == this.agreeItems.length &&
                selectedItem.s_required_flag == this.agreeRequired
            ) {
                let flag = true;
                this.agreeItems.map((t, i) => {
                    if (t.title != selectedItem.options[i].o_title) {
                        flag = false;
                    }
                });
                if (flag) {
                    this.closeAgreePopup();
                }
            } else {
                if (confirm('선택/동의정보가 변경되었습니다. 취소하시겠습니까?')) {
                    this.closeAgreePopup();
                }
            }
        },

        async onSaveAgree() {
            if (this.agreeName == '') {
                alert('항목명을 입력해주세요.');
                return;
            }

            if (this.agreeContent == '') {
                alert('내용을 입력해주세요.');
                return;
            }

            try {
                if (this.selectedAgreeIndex == -1) {
                    if (!confirm('동의/선택을 등록하시겠습니까?')) {
                        return;
                    }
                } else {
                    const selectedItem = this.agreeList[this.selectedAgreeIndex];
                    if (
                        selectedItem.s_title == this.agreeName &&
                        selectedItem.s_content == this.agreeContent &&
                        selectedItem.options &&
                        this.agreeItems &&
                        selectedItem.options.length == this.agreeItems.length &&
                        selectedItem.s_required_flag == this.agreeRequired
                    ) {
                        let flag = true;
                        this.agreeItems.map((t, i) => {
                            if (t.title != selectedItem.options[i].o_title) {
                                flag = false;
                            }
                        });
                        if (flag) {
                            alert('변경된 정보가 없습니다..');
                            return;
                        }
                    }

                    if (!confirm('선택/동의를 변경하시겠습니까?')) {
                        return;
                    }
                }

                if (this.commonFlag) {
                    const { data } = await api.post(`/admin/api/term/electronic/contract/agree`, {
                        id: this.selectedAgreeIndex == -1 ? 0 : this.agreeList[this.selectedAgreeIndex].s_id,
                        title: this.agreeName,
                        content: this.agreeContent,
                        agreeRequired: this.agreeRequired,
                        options: this.agreeItems,
                    });

                    if (data) {
                        if (this.selectedAgreeIndex == -1) {
                            alert('The agree has been registered.');
                        } else {
                            alert('The agree has been modified.');
                        }
                        this.closeAgreePopup();
                    }
                } else {
                    const { data } = await api.post(
                        `/admin/api/term/${this.centerId}/${this.centerStaffId}/electronic/contract/agree`,
                        {
                            id: this.selectedAgreeIndex == -1 ? 0 : this.agreeList[this.selectedAgreeIndex].s_id,
                            title: this.agreeName,
                            content: this.agreeContent,
                            agreeRequired: this.agreeRequired,
                            options: this.agreeItems,
                        }
                    );

                    if (data) {
                        if (this.selectedAgreeIndex == -1) {
                            alert('선택/동의가 등록되었습니다.');
                        } else {
                            alert('선택/동의가 변경되었습니다.');
                        }
                        this.closeAgreePopup();
                    }
                }

                this.onSearchAgreeList();
            } catch (error) {
                console.log(error);
            }
        },

        onAddSelectionBox() {
            this.agreeItems.push({ title: '', checked: false });
        },

        onDeleteOption(index) {
            this.agreeItems.splice(index, 1);
        },

        onKeyupTermContent(event) {
            if (event.key == 'Backspace') return;

            if (this.termContent.length >= 1 && this.termContent.substr(0, 1) != '•') {
                this.termContent = '• ' + this.termContent;
            }

            if (event.key == 'Enter') {
                this.termContent += '• ';
            }
        },

        onKeyupAgreeContent(event) {
            if (event.key == 'Backspace') return;

            if (this.agreeContent.length >= 1 && this.agreeContent.substr(0, 1) != '•') {
                this.agreeContent = '• ' + this.agreeContent;
            }

            if (event.key == 'Enter') {
                this.agreeContent += '• ';
            }
        },

        onKeydown(event) {
            // if (event.keyCode == 32) {
            //     return event.preventDefault();
            // }
        },
    },
};
</script>
<style lang="scss"></style>
